import { casaCampanaApi } from '@/core/config'
import { errorHandler } from '@/core/utils/axiosErrorHandler'

const AuthServices = {
  async login(form) {
    try {
      const data = await casaCampanaApi.post('/public/ecommerce/login', form)
      return data
    } catch (err) {
      const error = errorHandler('Error en el login')
      throw new Error(error.message)
    }
  },
}

export default AuthServices